import { editorStateForEditorComponent } from 'Shared/utils/draftJsHelpers';

export const SECTION_HEADER_TITLE_TYPE = 'section-header-title';

export function suggestionsFilter(searchValue, suggestions) {
  const value = searchValue.toLowerCase();
  const filteredSuggestions = suggestions.filter(
    suggestion => !value || suggestion?.mentionEntryName.toLowerCase().indexOf(value) > -1
  );
  const length = filteredSuggestions.length < 5 ? filteredSuggestions.length : 5;
  return filteredSuggestions.slice(0, length);
}

export function bodyWithoutDescription(bodyString) {
  if (!bodyString) return '';

  const body = JSON.parse(bodyString);
  const isSectionTitlePresent = Boolean(body.blocks.find(({ type }) => type === SECTION_HEADER_TITLE_TYPE));

  if (isSectionTitlePresent) {
    const newBody = {
      ...body,
      blocks: body.blocks.filter(({ type }) => type === SECTION_HEADER_TITLE_TYPE),
    };
    return editorStateForEditorComponent(JSON.stringify(newBody));
  }

  return editorStateForEditorComponent(bodyString);
}

export function sanitizeHrefValue(href) {
  return href?.startsWith('data') ? null : href;
}
